// extracted by mini-css-extract-plugin
module.exports = {"root":"yFKaF","lang":"_3f0ED","separator":"_2voCA","user":"i9FkD"};